module.exports = __webpack_public_path__ + "img/dfaa3b7.jpg";